export const prepareGradePageTitle = (prefix: string, suffix: string, item: string, parent: string) => {
  return `${parent && `${parent} `}${prefix && `${prefix} `}${item} ${suffix}`;
};
